import { computed } from 'vue'
import type { Item } from '@/interfaces'
import type { Ref } from '@vue/reactivity'

export function useMaterials(currentMaterials: Ref<any[]>, limit: number = 5) {

    const addMaterialDisabled = computed(() => currentMaterials.value.length >= limit);
    const removeMaterialDisabled = computed(() => currentMaterials.value.length === 0);
    const hasEmptyMaterials = computed(() => currentMaterials.value.length >= 1 && currentMaterials.value.some((material: Item) => material.amount === null || material.amount === 0 || material.id === null || material.id === 0));

    function addMaterial(): void {
        currentMaterials.value = [...currentMaterials.value, { id: null, amount: null }];
    }

    function removeMaterial(): void {
        currentMaterials.value = currentMaterials.value.toSpliced(currentMaterials.value.length - 1, 1);
    }

    return {
        materials: currentMaterials,
        addMaterial,
        removeMaterial,
        hasEmptyMaterials,
        addMaterialDisabled,
        removeMaterialDisabled
    };
}